export const normalizeExternalUrl = (url?: string | null) => {
  if (!url) return '';
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
};
